import React, { useState } from 'react';
import {payload} from "../../widgets/custom/table-panels/mockData"
export interface ISelectionDataModel {

    layerName:string|undefined;
    features: any[];
	geometryType:string;
    //globalIdFieldName:string|undefined;
    //objectIdFieldName:string|undefined;
   // spatialReference:any;
    fields:any[];
	popupFields:any[]
    //fieldAliases:any;
    //url:string

}

export interface ISelectDataContext {
	data:ISelectionDataModel[]|undefined
}

export const selectionDataContext:any = React.createContext<ISelectDataContext>({} as ISelectDataContext);
export const SelectionDataContextProvider = (props: { children: React.ReactNode }) => {
	const [selectionData, setSelectionData] = useState<any>([]);
	return (
		<selectionDataContext.Provider
			value={{
				data: selectionData,
				set: (e:ISelectionDataModel) => {
					setSelectionData(e);
				},
				setSelectionData:setSelectionData
			}}
		>
			{props.children}
		</selectionDataContext.Provider>
	);

};